import { Check, Close, ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import {
  CancellationDueDeath,
  JudgmentDataForm,
} from 'cancellations/view-models/cancellation-due-death';
import { memo, useEffect, useMemo } from 'react';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import JudgmentDataFormComponentMemo from './judgment-data-form';

interface JudgmentDataAccordionProps {
  expanded: boolean;
  toggle: () => void;
  disabled?: boolean;
}

const JudjmentDataAccordionComponent = ({
  expanded,
  toggle,
  disabled: disabledProps,
}: JudgmentDataAccordionProps): React.ReactElement => {
  const formContext = useFormikContext<CancellationDueDeath>();
  const { judgmentDataForm, changeControlDataForm } = formContext.values;
  const errors: FormikErrors<JudgmentDataForm> | undefined = formContext.errors
    .judgmentDataForm as FormikErrors<JudgmentDataForm>;
  const touched: FormikTouched<JudgmentDataForm> | undefined = formContext.touched
    .judgmentDataForm as unknown as FormikTouched<JudgmentDataForm>;

  const disabled = useMemo(
    () => changeControlDataForm?.cancellationReason === '1' || disabledProps,
    [changeControlDataForm?.cancellationReason, disabledProps]
  );

  const handleFormFieldChange = useEventCallback(
    (key: keyof JudgmentDataForm, value: JudgmentDataForm[keyof JudgmentDataForm]) => {
      const newForm = {
        ...judgmentDataForm,
        [key]: value,
      };
      formContext.setFieldValue('judgmentDataForm', newForm);
    }
  );

  useEffect(() => {
    if (disabled) {
      // reset accordion
      formContext.setFieldValue('judgmentDataForm', {
        judgmentNumber: '',
        judgmentDate: null,
        validityDate: null,
        authority: '',
        courtType: '',
        isItalianAuthority: false,
      });
    }
  }, [disabled]);

  return (
    <Accordion expanded={expanded} onChange={toggle}>
      <AccordionSummary
        aria-controls="panel-judgment-data-content"
        id="panel-judgment-data-content"
        expandIcon={<ExpandMore />}
      >
        {!!errors ? <Close color="error" /> : <Check color="success" />}
        <Typography>Sentenza</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <JudgmentDataFormComponentMemo
          errors={errors}
          touched={touched}
          judgmentDataForm={judgmentDataForm}
          handleFormFieldChange={handleFormFieldChange}
          disabled={disabled}
        />
      </AccordionDetails>
    </Accordion>
  );
};

JudjmentDataAccordionComponent.displayName = 'Judgment data accordion component';

const JudgmentDataAccordion = memo(JudjmentDataAccordionComponent);

export default JudgmentDataAccordion;
